import { render, staticRenderFns } from "./ManageTemplateAccess.vue?vue&type=template&id=ff360ac8&"
import script from "./ManageTemplateAccess.vue?vue&type=script&lang=ts&"
export * from "./ManageTemplateAccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports